import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignDraftsHandoff } from '@/pages/workspaces/automations/[campaignId]/drafts/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/drafts',
)({
  component: JourneysCampaignDraftsHandoff,
});
